"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const BaseInput_1 = __importDefault(require("./BaseInput"));
const clsx_1 = __importDefault(require("clsx"));
const Input = react_1.forwardRef(function InputInternal({ rounded = 'all', ...props }, ref) {
    return (react_1.default.createElement(BaseInput_1.default, Object.assign({ ref: ref }, props, { className: clsx_1.default('placeholder-gray-500 dark:bg-black-600 focus:border-highlight-300 focus:ring-highlight-500', 'relative focus:z-10 block px-3 py-2 w-full', 'text-gray-900 dark:text-white border border-gray-300 dark:border-gray-800', 'focus:outline-none appearance-none sm:text-sm sm:leading-5', { 'rounded-md ': rounded === 'all' }, { 'rounded-none  rounded-b-md': rounded === 'bottom' }, { 'rounded-none  rounded-t-md': rounded === 'top' }) })));
});
exports.default = Input;
